// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__-qUFP","radioRow":"SimpleQuestionBuilderModal_radioRow__2YdhZ"};